import React from 'react';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import './tooltip.css';
import './style.css';

const SliderWithToolTip = createSliderWithTooltip(Slider);
const SliderStyle = ({ children, ...rest }) => (
  <SliderWithToolTip className="slider-style" {...rest}>
    {children}
  </SliderWithToolTip>
);


export default SliderStyle;
